import { render, staticRenderFns } from "./BuyButton.vue?vue&type=template&id=ddd7a8ea&scoped=true&"
import script from "./BuyButton.vue?vue&type=script&lang=js&"
export * from "./BuyButton.vue?vue&type=script&lang=js&"
import style0 from "./BuyButton.vue?vue&type=style&index=0&id=ddd7a8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd7a8ea",
  null
  
)

export default component.exports